import React from 'react';
import Component from ".";
import authRoles from "../../utils/auth.roles";
import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from "react-redux";

const withNotificationBlock = (Component) => {
  const WrappedComponent = (props) => {
    const notification = useSelector(({ Auth }) => Auth.notification);
    const location = useLocation();
    if (notification?.isEnabled) {
      return <Navigate to="/home" state={{ from: location }} replace />;
    }
    return <Component {...props} />;
  };
  WrappedComponent.displayName = `WithNotificationBlock(${Component.displayName || Component.name || 'Component'})`;
  return WrappedComponent;
};

const GuardedRecurringPayment = withNotificationBlock(Component);
const RecurringPaymentRoutes = {
  auth: authRoles.user,
  kyc: false,
  routes: [
    {
      path: "/recurring-payment",
      component: GuardedRecurringPayment,
      exact: true,
    },
  ],
};
export default RecurringPaymentRoutes;
